import React, { useState, useEffect } from "react";
import AboutMe from "./components/AboutMe";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="h-screen flex items-center justify-center overflow-hidden animated-gradient">
      <div
        className={`relative -top-[15vh] transition-all duration-500 ease-out ${
          isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <AboutMe />
      </div>
    </div>
  );
}

export default App;
